<template>
  <section class="content-width">
    <h2>Who is Autumn?</h2>

    <div class="sidebar">
      <h3>The most sweet, beautiful, gorgeous, wonderful, smart woman in the entire world, of course.</h3>
    </div>
  </section>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
@import '@/styles/sizes.scss';

h3 {
  margin: 24px 0 4px;

  @include break-phone {
    margin: 16px 0 4px;
  }
}
</style>
